import React, { useState, useEffect } from 'react';

const clientLogos = [
  '/siteassets/images/logo/logo-1.webp',
  '/siteassets/images/logo/logo-2.webp',
  '/siteassets/images/logo/logo-3.webp',
  '/siteassets/images/logo/ais_window.webp',
  '/siteassets/images/logo/logo-4.webp',
  '/siteassets/images/logo/logo-5.webp',
  '/siteassets/images/logo/logo-6.webp',
  '/siteassets/images/logo/logo-7.webp',
  '/siteassets/images/logo/logo-8.webp',
  '/siteassets/images/logo/logo-9.webp',
  '/siteassets/images/logo/windseild.webp',
  '/siteassets/images/logo/logo-10.webp',
  '/siteassets/images/logo/logo-11.webp',
  '/siteassets/images/logo/logo-12.webp',
  '/siteassets/images/logo/logo-13.webp',
  '/siteassets/images/logo/parle-logo.png',
  '/siteassets/images/logo/jnu-logo.png',
  
  '/siteassets/images/logo/pebble-logo.png',
  '/siteassets/images/logo/littletag-logo.png',
  '/siteassets/images/logo/retag-logo.png',
  '/siteassets/images/logo/okinawa.png',
  '/siteassets/images/logo/skipper.png',
  '/siteassets/images/logo/spark-minda.png',
];

export default function ClientSlider() {
  const [isHovered, setIsHovered] = useState(false);

  const formatAlt = (src: string) => {
    try {
      const name = src.split('/').pop()?.split('.')[0] || 'client';
      return `Client logo — ${name.replace(/[-_]/g, ' ')}`;
    } catch (e) {
      return 'Client logo';
    }
  };

  // Create multiple sets of logos for seamless infinite scroll
  const duplicatedLogos = [...clientLogos, ...clientLogos, ...clientLogos];

  return (
    <section className="bg-gray-50 py-16">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Our <span className="text-blue-600">Clients</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Trusted by industry leaders and growing businesses worldwide
          </p>
        </div>

        {/* Infinite Scrolling Slider */}
        <div 
          className="relative overflow-hidden"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {/* Slider Track with CSS Animation */}
          <div 
            className={`flex infinite-scroll ${isHovered ? 'paused' : ''}`}
            style={{ 
              width: `${duplicatedLogos.length * 200}px`
            }}
          >
            {duplicatedLogos.map((src, index) => (
              <div 
                key={`${src}-${index}`}
                className="flex-shrink-0 w-48 h-32 mx-4"
              >
                <div className="h-full flex items-center justify-center p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300">
                  <img 
                    src={src} 
                    alt={formatAlt(src)} 
                    className="max-w-full max-h-full object-contain filter grayscale hover:grayscale-0 transition-all duration-500" 
                    loading="lazy" 
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

       
      </div>
    </section>
  );
}
